import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M20 16.2A4.5 4.5 0 0 0 17.5 8h-1.8A7 7 0 1 0 4 14.9",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "17", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 13v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 20v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 17h-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 17H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15 14-.88.88", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.88 19.12 9 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15 20-.88-.88", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9.88 14.88 9 14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CloudCog";
const CloudCog = memo(themed(Icon));
export {
  CloudCog
};
//# sourceMappingURL=cloud-cog.js.map
